export const radii = {
  xs: `.5rem`,
  sm: `1.5rem`,
  md: `3rem`,
  lg: `4rem`,
  xl: `5rem`
};
